export default __webpack_public_path__ + "locales/ar-SA/Notifications.json?hash=936090049404b79f251da9509fe50094";